import { AccountTypeInfo, RoleAssignmentMap } from '../user';

type CustomerAccountInfoBase = {
  id: string;
  name: string;
  type: AccountTypeInfo;
  oauthClientLimitN: number;
  roleAssignments: RoleAssignmentMap;
  member?: MemberInfo;
};

export type ServerCustomerAccountInfo = CustomerAccountInfoBase & {
  validTo: string;
};

export type CustomerAccountInfo = CustomerAccountInfoBase & {
  validTo: Date;
};

export function fromServerCustomerAccountInfo(
  accountInfo: ServerCustomerAccountInfo,
): CustomerAccountInfo {
  return {
    ...accountInfo,
    validTo: new Date(accountInfo.validTo),
  };
}

export type MemberInfo = {
  userId: string;
  roleLevel: number;
};
